// src/components/countries/Table/CountriesTableColumns.jsx
const CountriesTableColumns = [
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "code", labelAr: "الكود", labelEn: "Code", sortable: true },
];

export default CountriesTableColumns;
